import { FriendSuggestionCard } from './FriendSuggestionCard';
import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';
import { api } from '@/utils/api';

type PartialUser = {
  id: number;
  userId: string;
  username: string;
  firstName: string;
  lastName: string;
  imageUrl: string;
};

export default function FriendsRecommendation() {
  const { t } = useTranslation();
  const [friendSuggestions, setFriendSuggestions] = useState<PartialUser[]>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      const { data } = await api.get('/friendships/recommendations');

      setFriendSuggestions(data);
      setLoading(false);
    };

    fetchData();
  }, []);

  if (loading || !friendSuggestions || friendSuggestions?.length === 0) {
    return '';
  }

  return (
    <div>
      <h2 className="text-md font-bold text-muted-foreground">{t('friends_recommendation_title')}</h2>
      <div className="flex overflow-y-auto [-ms-scrollbar-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        <div className="flex items-stretch gap-3">
          {friendSuggestions?.map(friend => (
            <FriendSuggestionCard
              key={friend.userId}
              userId={friend.userId}
              name={`${friend.firstName} ${friend.lastName}`}
              username={friend.username}
              imageUrl={friend.imageUrl!}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
